import { useCallback, useEffect, useRef } from 'react';

const DEFAULT_MAX_FONT_SIZE = 14;
const DEFAULT_MIN_FONT_SIZE = 9;

export function useFitText(
  maxFontSize = DEFAULT_MAX_FONT_SIZE,
  minFontSize = DEFAULT_MIN_FONT_SIZE,
  maxWidth?: number,
  content?: string,
) {
  const elRef = useRef<HTMLElement | null>(null);
  const isMounted = useRef(false);

  const fit = useCallback(
    (el: HTMLElement | null) => {
      if (!el) return;
      const containerWidth = maxWidth ?? el.parentElement?.clientWidth;
      if (!containerWidth) return;
      let fontSize = maxFontSize;
      el.style.fontSize = `${fontSize}px`;
      while (el.scrollWidth > containerWidth && fontSize > minFontSize) {
        fontSize -= 0.5;
        el.style.fontSize = `${fontSize}px`;
      }
    },
    [maxFontSize, minFontSize, maxWidth],
  );

  const callbackRef = useCallback(
    (el: HTMLElement | null) => {
      elRef.current = el;
      fit(el);
    },
    [fit],
  );

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    if (elRef.current) fit(elRef.current);
  }, [content, fit]);

  return callbackRef;
}
